import { createSelector } from 'reselect';

const selectExpense = (state) => state.expenseNew;

export const selectExpensesInMonth = createSelector(
  [selectExpense],
  (billing) => billing.expensesInMonth,
);
